import React from 'react';

const HeroSection = () => {
  return (
    <section className="min-h-[60vh] flex items-center justify-center px-8 pt-16 pb-4 relative overflow-hidden bg-gradient-to-b from-pink-800 via-pink-900 to-pink-950">
      <div className="absolute inset-0 opacity-10 z-[1]">
        <div className="absolute top-[20%] left-[10%] w-15 h-15 bg-rose-100 bg-opacity-15 rounded-full animate-float"></div>
        <div className="absolute top-[60%] right-[15%] w-10 h-10 bg-rose-100 bg-opacity-15 rounded-full animate-float" style={{animationDelay: '2s'}}></div>
        <div className="absolute top-[40%] left-[80%] w-20 h-20 bg-rose-100 bg-opacity-15 rounded-full animate-float" style={{animationDelay: '4s'}}></div>
      </div>
      
      <div className="text-center max-w-4xl z-[2] relative">
        <h1 className="text-4xl md:text-6xl font-bold text-amber-50 mb-6 leading-tight tracking-tight drop-shadow-sm">
          Stuck on what to wear?<br />We've got you covered.
        </h1>
        <p className="text-lg md:text-xl text-amber-50 text-opacity-90 mb-12 font-normal max-w-2xl mx-auto">
          Professional styling advice for clothing and accessories that matches your lifestyle, budget, and vibe
        </p>
        
        <div className="flex justify-center items-center gap-2 mb-8 flex-wrap md:flex-nowrap">
          <div className="flex items-center gap-2 text-amber-50 text-opacity-85 text-sm">
            <svg className="w-5 h-5 fill-rose-100" viewBox="0 0 20 20">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <span>50k+ users trust us</span>
          </div>
          <div className="flex items-center gap-2 text-amber-50 text-opacity-85 text-sm">
            <svg className="w-5 h-5 fill-rose-100" viewBox="0 0 20 20">
              <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3z"/>
            </svg>
            <span>Clothing & accessories from top US retailers</span>
          </div>
          <div className="flex items-center gap-2 text-amber-50 text-opacity-85 text-sm">
            <svg className="w-5 h-5 fill-rose-100" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
            </svg>
            <span>Expert AI styling</span>
          </div>
        </div>
        
        <div className="mt-4 text-center">
          <p className="text-amber-50 text-opacity-90 text-lg mb-2">Upload a photo or describe your vibe below</p>
          <div>
            <div className="mb-1 text-base font-bold text-amber-50 text-opacity-70">Get Started</div>
            <svg className="w-6 h-6 mx-auto stroke-current stroke-2 fill-none text-amber-50 text-opacity-70 animate-bounce-slow" viewBox="0 0 24 24">
              <polyline points="6,9 12,15 18,9"></polyline>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;